import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/configuracoes/stores'
import sAutenticacao from '@/aplicacao/_autenticacao/_servicos/autenticacao'
import rotas from '@/aplicacao/_configuracoes/rotas'

Vue.use(VueRouter)

const router = new VueRouter({
    routes: rotas,
    mode: 'history',
    base: process.env.VUE_APP_BASE_URL,
    linkActiveClass: 'active',
    linkExactActiveClass: 'active',
})

router.beforeEach((to, from, next) => {

    store.dispatch('flash/tratarRemocao')

    if (store.state.geral.ehMobile) {
        store.dispatch('geral/menuModuloOcultar')
    }

    const tratarRedirecionamentoComunicados = () => {
        let rotaComunicadosDashboard = process.env.VUE_APP_ROTA_COMUNICADOS_DASHBOARD
        if (!to.name.includes(rotaComunicadosDashboard) && !to.name.includes('autenticacao-login')) {
            if (localStorage.getItem('comunicados')) {
                next({ name: rotaComunicadosDashboard, query: { redirect: to.fullPath }})
            } else {
                next()
            }
        } else {
            next()
        }
    }

    const fnRedirecionamentoParaLogin = () => {
        if (!to.name.includes('autenticacao-login')) {
            if (!to.name.includes('dashboard') && !to.name.includes('erro')) {
                next({ path: '/login', query: { redirect: to.fullPath }})
            } else {
                next({ path: '/login' })
            }
        } else {
            tratarRedirecionamentoComunicados()
        }
    }

    const fnVerificacaoPermissoes = () => {
        if (to.meta.hasOwnProperty('permissao') && ('' !== to.meta.permissao)) {
            let permissoesUsuarioLogado = store.state['sessao'].permissoes
            let temPermissaoParaRota = permissoesUsuarioLogado.includes(to.meta.permissao)
            if (!temPermissaoParaRota) {
                next({ name: 'erro-403-forbidden' })
            } else {
                tratarRedirecionamentoComunicados()
            }
        } else {
            tratarRedirecionamentoComunicados()
        }
    }

    const fnVerificacaoAutenticacao = () => {
        if (to.hasOwnProperty('meta') && to.meta.hasOwnProperty('autenticacao') && (true === to.meta.autenticacao)) {
            if (localStorage.getItem('token')) {
                if (store.state['sessao'].usuario.id) {
                    fnVerificacaoPermissoes()
                } else {
                    sAutenticacao.refreshServer()
                        .then(dados => {

                            sAutenticacao.refreshClient(dados)

                            if ('development' !== process.env.NODE_ENV) {
                                setTimeout(() => {
                                    sAutenticacao.verificarSessao()
                                }, parseInt(process.env.VUE_APP_REFRESH_DELAY))
                            }

                            if (store.state['sessao'].usuario.id) {
                                fnVerificacaoPermissoes()
                            } else {
                                fnRedirecionamentoParaLogin()
                            }

                        })
                        .catch(err => {
                            fnRedirecionamentoParaLogin()
                        })
                }
            } else {
                fnRedirecionamentoParaLogin()
            }
        } else {
            tratarRedirecionamentoComunicados()
        }
    }

    fnVerificacaoAutenticacao()

})

Vue.router = Vue.observable(router)

export default router
